function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import QMenu from '../menu/QMenu.js';
import QBtn from '../btn/QBtn.js';
import AttrsMixin from '../../mixins/attrs.js';
import clone from '../../utils/clone.js';
import { isDeepEqual } from '../../utils/is.js';
import { slot } from '../../utils/slot.js';
import { isKeyCode } from '../../utils/key-composition.js';
import cache from '../../utils/cache.js';
export default Vue.extend({
  name: 'QPopupEdit',
  mixins: [AttrsMixin],
  props: {
    value: {
      required: true
    },
    title: String,
    buttons: Boolean,
    labelSet: String,
    labelCancel: String,
    color: {
      type: String,
      "default": 'primary'
    },
    validate: {
      type: Function,
      "default": function _default() {
        return true;
      }
    },
    autoSave: Boolean,

    /* menu props overrides */
    cover: {
      type: Boolean,
      "default": true
    },
    contentClass: String,

    /* end of menu props */
    disable: Boolean
  },
  data: function data() {
    return {
      modelChanged: false,
      model: null
    };
  },
  computed: {
    classes: function classes() {
      return 'q-popup-edit' + (this.contentClass !== void 0 ? " ".concat(this.contentClass) : '');
    },
    modelValue: function modelValue() {
      return this.modelChanged === true ? this.model : this.value;
    },
    initialValue: function initialValue() {
      return this.modelChanged !== true ? this.model : this.value;
    },
    defaultSlotScope: function defaultSlotScope() {
      var _this = this;

      var acc = {
        initialValue: this.initialValue,
        updatePosition: this.__reposition,
        emitValue: this.__changeModel,
        validate: this.validate,
        set: this.set,
        cancel: this.cancel
      };
      Object.defineProperty(acc, 'value', {
        get: function get() {
          return _this.modelValue;
        },
        set: this.__changeModel
      });
      return acc;
    },
    menuProps: function menuProps() {
      return _objectSpread(_objectSpread({}, this.qAttrs), {}, {
        cover: this.cover,
        contentClass: this.classes
      });
    }
  },
  methods: {
    set: function set() {
      if (this.validate(this.modelValue) !== true) {
        return;
      }

      if (this.__hasChanged() === true) {
        this.$emit('save', this.modelValue, this.initialValue);
        this.modelChanged === true && this.$emit('input', this.modelValue);
      }

      this.__close();
    },
    cancel: function cancel() {
      if (this.__hasChanged() === true) {
        this.$emit('cancel', this.modelValue, this.initialValue);
        this.modelChanged !== true && this.$emit('input', this.initialValue);
      }

      this.__close();
    },
    show: function show(e) {
      this.$refs.menu !== void 0 && this.$refs.menu.show(e);
    },
    hide: function hide(e) {
      this.$refs.menu !== void 0 && this.$refs.menu.hide(e);
    },
    __hasChanged: function __hasChanged() {
      return isDeepEqual(this.modelValue, this.initialValue) === false;
    },
    __changeModel: function __changeModel(val) {
      if (this.disable !== true) {
        this.model = val;
        this.modelChanged = true;
      }
    },
    __close: function __close() {
      this.validated = true;
      this.$refs.menu.showing === true && this.$refs.menu.hide();
    },
    __reposition: function __reposition() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.menu.updatePosition();
      });
    },
    __getContent: function __getContent(h) {
      var title = slot(this, 'title', this.title),
          child = this.$scopedSlots["default"] === void 0 ? [] : [].concat(this.$scopedSlots["default"](this.defaultSlotScope));
      title && child.unshift(h('div', {
        staticClass: 'q-dialog__title q-mt-sm q-mb-sm'
      }, [title]));
      this.buttons === true && child.push(h('div', {
        staticClass: 'q-popup-edit__buttons row justify-center no-wrap'
      }, [h(QBtn, {
        props: {
          flat: true,
          color: this.color,
          label: this.labelCancel || this.$q.lang.label.cancel
        },
        on: cache(this, 'cancel', {
          click: this.cancel
        })
      }), h(QBtn, {
        props: {
          flat: true,
          color: this.color,
          label: this.labelSet || this.$q.lang.label.set
        },
        on: cache(this, 'ok', {
          click: this.set
        })
      })]));
      return child;
    }
  },
  render: function render(h) {
    var _this3 = this;

    if (this.disable === true) {
      return;
    }

    return h(QMenu, {
      ref: 'menu',
      props: this.menuProps,
      on: cache(this, 'menu', {
        'before-show': function beforeShow() {
          _this3.validated = false;
          _this3.modelChanged = false;
          _this3.model = clone(_this3.value);
          _this3.watcher = _this3.$watch('value', _this3.__reposition);

          _this3.$emit('before-show');
        },
        show: function show() {
          _this3.$emit('show');
        },
        'escape-key': this.cancel,
        'before-hide': function beforeHide() {
          _this3.watcher();

          if (_this3.validated === false && _this3.__hasChanged() === true) {
            if (_this3.autoSave === true && _this3.validate(_this3.model) === true) {
              _this3.$emit('save', _this3.modelValue, _this3.initialValue);

              _this3.modelChanged === true && _this3.$emit('input', _this3.modelValue);
            } else {
              _this3.$emit('cancel', _this3.modelValue, _this3.initialValue);

              _this3.modelChanged !== true && _this3.$emit('input', _this3.initialValue);
            }
          }

          _this3.$emit('before-hide');
        },
        hide: function hide() {
          _this3.$emit('hide');
        },
        keyup: function keyup(e) {
          isKeyCode(e, 13) === true && _this3.set();
        }
      })
    }, this.__getContent(h));
  }
});